/**
 * DefinitionManager module
 *
 * This module manager content definitions
 *
 */

'use strict';

const _ = require('lodash');

const DefinitionManager = {};
let container = {};

/**
 * Add definitions
 *
 * @param {Array} definitions
 * @returns {object} DefinitionManager
 */
DefinitionManager.add = function(definitions) {
    if (!definitions || !_.isArray(definitions)) {
        throw new Error('Definitions must be an array');
    }

    _.forEach(definitions, function(definition) {
        container[definition.type] = definition;
    });

    return this;
};

/**
 * Retrieve definition by type
 *
 * @param  {string} type
 * @returns {object | null} definition
 */
DefinitionManager.get = function(type) {
    return container[type] || null;
};

/**
 * Retrieve all definitions
 *
 * @returns {object} definitions
 */
DefinitionManager.getAll = function() {
    return container;
};

/**
 * Clear all definitions
 *
 * @returns {object} DefinitionManager
 */
DefinitionManager.clear = function() {
    container = {};

    return this;
};

module.exports = DefinitionManager;
